import { Tabs } from 'common/constants';
import {
  LEFT_CARD,
  RIGHT_MAIN_CARD,
  SKELETON_LOADER_STYLE,
  STORE
} from './constants';
import { SkeletonLoader } from './SkeletonLoader';
import { StyledColumn, StyledDiv, StyledRow } from './styled';
import { LoaderStyle, SkeletonHeaderProps } from './types';
import type { FC } from 'react';

export const SkeletonHeaderLayout: FC<SkeletonHeaderProps> = ({ type }) => {
  switch (type) {
    case STORE:
      return (
        <StyledRow>
          <StyledColumn>
            <StyledDiv variant={LEFT_CARD}>
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width200}
              />
            </StyledDiv>
          </StyledColumn>
        </StyledRow>
      );

    case Tabs.NeedsAuthorization:
      return (
        <StyledRow>
          <StyledColumn>
            <StyledDiv variant={RIGHT_MAIN_CARD}>
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width150}
                style={{ marginRight: 10 }}
              />
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width150}
              />
            </StyledDiv>
          </StyledColumn>
        </StyledRow>
      );

    case Tabs.PrintChecks:
      return (
        <StyledRow>
          <StyledColumn>
            <StyledDiv variant={LEFT_CARD}>
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width250}
              />
            </StyledDiv>
          </StyledColumn>

          <StyledColumn>
            <StyledDiv variant={RIGHT_MAIN_CARD}>
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width150}
                style={SKELETON_LOADER_STYLE}
              />
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width150}
              />
            </StyledDiv>
          </StyledColumn>
        </StyledRow>
      );

    case Tabs.ToBePaid:
      return (
        <StyledRow>
          <StyledColumn>
            <StyledDiv variant={RIGHT_MAIN_CARD}>
              <SkeletonLoader
                height={LoaderStyle.height}
                width={LoaderStyle.width150}
              />
            </StyledDiv>
          </StyledColumn>
        </StyledRow>
      );
    default:
      return null;
  }
};
